import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import useTendering from "../../../hooks/useTendering";
import useQuotation from "../../../hooks/useQuotation";
import TenderingDetailContext from "../context";
import List, { STATE } from "../../../components/List";
import { format } from "date-fns";
import { formatNumber } from "../../../helpers/common.helper";
import SecondaryPagination from "../../../components/SecondaryPagination/SecondaryPagination";
import { ReactComponent as EveSvg } from "../../../assets/tendering/eye.svg";
import { ReactComponent as DownloadSvg } from "../../../assets/tendering/download.svg";
import { toast } from "react-toastify";

const assetsUri = import.meta.env.ASSETS_URI;

const Quotations = (props) => {
  const { details } = useContext(TenderingDetailContext);
  const {} = useTendering();
  const { queryQuotation } = useQuotation();
  const [datasource, setDatasource] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [metadata, setMetadata] = useState(undefined);
  const [fetchingState, setFetchingState] = useState(STATE.LOADING);

  useEffect(() => {
    _refetch();
  }, []);

  const handleDownloadFile = async (fileName, path) => {
    await toast.promise(
      new Promise(async (resolve, reject) => {
        const res = await fetch(path, { cache: "no-cache" });
        const blob = await res.blob();

        saveAs(blob, fileName);

        resolve();
      }),
      {
        pending: "Downloading",
        success: "File downloaded",
        error: "Failed to download",
      },
      {
        autoClose: 1000,
      }
    );
  };

  const _refetch = (_limit, _page) => {
    let quotationIds = details.contractor.quotations;

    queryQuotation(
      {
        _id: {
          $in: quotationIds,
        },
        active: true,
        deleted: false,
      },
      _page ?? page,
      _limit ?? limit
    ).then(({ data, _metadata }) => {
      setMetadata(_metadata);

      // * Sort data
      const _sorted = data.sort((a, b) => {
        if (new Date(a.createdOn) < new Date(b.createdOn)) return 1;

        return -1;
      });

      setDatasource(
        _sorted.map((d, index) => ({
          _id: d._id,
          code: d.code,
          date: format(new Date(d.createdOn), "dd MMM yyyy"),
          remark: "",
          cost: formatNumber(d.grandTotal, "THB"),
          status: index === 0 ? "Active" : "Cancelled",
          actions: (
            <div className="tendering-documents__quotations__list__actions">
              <div
                className="tendering-documents__quotations__list__actions__action"
                onClick={() => {
                  handleDownloadFile(d.file.name, `${assetsUri}/${d.file.key}`);
                }}
              >
                <DownloadSvg width={18} height={18} />
              </div>
            </div>
          ),
        }))
      );
      setFetchingState(STATE.IDLE);
    });
  };

  return (
    <div className="tendering-documents__quotations">
      <h2>Quotations</h2>
      <List
        contentState={fetchingState}
        scrollable={true}
        columns={[
          {
            display: "Document No",
            key: "code",
            textAlign: "left",
            width: 150,
          },
          {
            display: "Date",
            key: "date",
            textAlign: "left",
            width: 100,
          },
          {
            display: "Remarks",
            key: "remark",
            textAlign: "left",
          },
          {
            display: "Cost",
            key: "cost",
            textAlign: "left",
            width: 200,
          },
          {
            display: "Status",
            key: "status",
            textAlign: "left",
          },
          {
            display: "",
            key: "actions",
            textAlign: "left",
          },
        ]}
        dataSource={datasource}
      >
        <SecondaryPagination
          defaultLimit={limit}
          limits={[1, 10, 50]}
          pages={metadata?.totalPages || 1}
          onPageChange={(page) => {
            setPage(page);
            setFetchingState(STATE.LOADING);
            _refetch(undefined, page);
          }}
          onLimitChange={(limit) => {
            setLimit(limit);
            setPage(1);
            setFetchingState(STATE.LOADING);
            _refetch(limit, 1);
          }}
        />
      </List>
    </div>
  );
};

Quotations.propTypes = {};

export default Quotations;
